module.exports = __webpack_public_path__ + "static/media/speaker_SchindlerAufzuge_DennisBrosi.0cd10795.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_SchindlerAufzuge_DennisBrosi.jpg
// module id = 252
// module chunks = 0